import React from 'react';
import PlaceholderPage from '../components/common/PlaceholderPage';

const backuprecoveryPage: React.FC = () => {
  return (
    <PlaceholderPage
      title="Backup & Recovery"
      description="Data backup and recovery"
      features={["Backup Scheduling","Recovery Procedures","Data Protection","Disaster Recovery"]}
      comingSoon={true}
    />
  );
};

export default backuprecoveryPage;
